import { Injectable } from '@angular/core';
import {CurrentUserProfileResponse} from '../dto/response/CurrentUserProfileResponse';
import {UserProfileDto} from '../dto/UserProfileDto';
import {UpdateCurrentUserProfileRequest} from '../dto/request/UpdateCurrentUserProfileRequest';

@Injectable({
  providedIn: 'root',
})
export class ProfileMapper {

  fromCurrentProfileResponse(response: CurrentUserProfileResponse): UserProfileDto {
    let birthdate = response.birthdate ?? '';
    if (birthdate && birthdate.includes('-')) {
      const parts = birthdate.split('-');
      if (parts.length === 3 && parts[0].length === 2) {
        // dd-MM-yyyy -> yyyy-MM-dd
        birthdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
    }

    return new UserProfileDto(
      response.profile_uuid,
      response.image_url ?? '',
      response.username ?? '',
      birthdate,
      response.about ?? '',
      response.email
    );
  }

  toUpdateCurrentUserProfileRequest(profile: UserProfileDto): UpdateCurrentUserProfileRequest {
    let birthdate = '';
    if (profile.birthdate) {
      // profile.birthdate is yyyy-MM-dd from <input type="date">
      const parts = profile.birthdate.split('-');
      if (parts.length === 3 && parts[0].length === 4) {
        // yyyy-MM-dd -> dd-MM-yyyy
        birthdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
      } else {
        // Fallback for other formats if any
        const date = new Date(profile.birthdate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        birthdate = `${day}-${month}-${year}`;
      }
    }
    return new UpdateCurrentUserProfileRequest(
      profile.imageUrl,
      profile.username,
      birthdate,
      profile.about
    );
  }

}
